import { render } from "./VerifyEmailBody.vue?vue&type=template&id=172120c3&scoped=true"
import script from "./VerifyEmailBody.vue?vue&type=script&lang=js"
export * from "./VerifyEmailBody.vue?vue&type=script&lang=js"

import "./VerifyEmailBody.vue?vue&type=style&index=0&id=172120c3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172120c3"]])

export default __exports__